import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import { primeUiSounds, playSuccess, playError } from "@/lib/sounds";

primeUiSounds();
const _ok = toast.success.bind(toast);
const _err = toast.error.bind(toast);
toast.success = (...a) => { playSuccess(); return _ok(...a); };
toast.error = (...a) => { playError(); return _err(...a); };

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__gaInstallEvt = e;
  window.dispatchEvent(new Event("ga-install-ready"));
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
